import { memo } from 'react';

import { ICartProduct } from '@/store/ducks/order/types';
import { IProduct } from '@/store/ducks/products/types';

interface Props {
  product: IProduct | ICartProduct;
}

function OptionsImage({ product }: Props) {
  return (
    <>
      {product.images[0] && (
        <div className="col-12 col-md-4 options-image">
          <img className="img-fluid " src={product.images[0]} alt={product.title} />
        </div>
      )}
    </>
  );
}

export default memo(OptionsImage);
